/**
 * 账号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request'

//获取当前医馆
export const currentDept = (params) => {
    return req.get('/currentDept', params)
}

//切换医馆
export const switchDept = (params) => {
    return req.get('/switchDept', params)
}


